import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   CAISSON — la pièce de COMPLEXE MILITAIRE. Un porteur, pas une cible.

   C'est le socle sur lequel se montent les sentinelles (voir les placements de
   la campagne : `obstacle: 'complexe-caisson'` avec des `sentinels`). Il est
   INDESTRUCTIBLE, et ce n'est pas un choix d'équilibrage mais d'identité : un
   complexe militaire n'explose pas parce qu'on a raboté une coque de station.
   Ce que le joueur détruit, ce sont ses CANONS (les sentinelles ancrées) ; le
   caisson, lui, on ne fait que l'esquiver — il ferme un pan de terrain et impose
   un côté, exactement comme le Colosse, mais armé.

   `radius: 60` : entre le Bloc (42) et le Colosse (82). Assez large pour porter
   deux sentinelles et fermer une demi-voie, assez étroit pour laisser un couloir
   de chaque côté — la menace du complexe est ses canons, pas son encombrement.

   `hp` posé mais inerte (le drapeau prime), comme le Colosse : une valeur
   nominale pour qu'un futur mode « caisson fragilisable » n'ait qu'à basculer le
   drapeau.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'complexe-caisson',
  radius: 60,
  hp: 1,
  destructible: false,
});
